/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import events from './events.directive';
import EventDescriptionDetailsController from './event-description-details.controller';

export default angular.module('tektelic.event', [events])
    .controller('EventDescriptionDetailsController', EventDescriptionDetailsController)
    .name;



// WEBPACK FOOTER //
// ./src/app/event/index.js